/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';

import { useLocation, useParams } from '@thd-olt-component-react/router';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore, ExperienceContext } from '@thd-nucleus/experience-context';

import {
  ProductInformation,
  RentalReservationModifyFormProviders,
  ReservationModifyForm
} from '@thd-olt-component-react/rental-reservation-form';

import { getConfigLists, useFeatureCheck } from '../helpers';

import '../styles/pages/ManageReservation.scss';

export const ManageReservation = () => {
  const { channel } = useContext(ExperienceContext);
  const { search: query } = useLocation();
  const { uuid, reservationId, storeId } = useParams();
  const isMobile = channel === 'mobile';

  const queryParams = {};
  query.replace('?', '').split('&').forEach((param) => {
    let [key, value] = param.split('=');
    queryParams[key] = value;
  });
  const { itemId } = queryParams;

  const localizedStore = useStore({ online: false });

  const {
    fdaV4Enabled = false,
    estimateGraphQlEnabled = false,
    pricingGraphQlEnabled = false,
    reservationGraphQlEnabled = false
  } = getConfigLists();

  const isFdaV4Enabled = useFeatureCheck(fdaV4Enabled, localizedStore?.storeId?.padStart(4, '0'));
  const isEstimateGraphQlEnabled = useFeatureCheck(estimateGraphQlEnabled, localizedStore?.storeId?.padStart(4, '0'));
  const isPricingGraphQlEnabled = useFeatureCheck(pricingGraphQlEnabled, localizedStore?.storeId?.padStart(4, '0'));
  const isReservationGraphQlEnabled = useFeatureCheck(
    reservationGraphQlEnabled,
    localizedStore?.storeId?.padStart(4, '0')
  )

  return (
    <QueryProvider
      defaultVariables={{ dataSource: 'catalog', fetchPolicy: 'cache-first', skipKPF: true }}
      cacheKey={`rental-manage-reservations-${isMobile ? 'mobile' : 'desktop'}`}
    >
      <Row className="isBound">
        <meta name="robots" content="noindex" />
        <ErrorBoundary name="breadcrumbs">
          <Col>
            <div className="breadcrumbs" style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <a href="//www.homedepot.com/" className="link">Home</a><div className="breadcrumbs-spacer">/</div>
              <a href="//www.homedepot.com/c/tool_and_truck_rental" className="link">
                Tool, Truck &amp; Equipment Rental
              </a><div className="breadcrumbs-spacer">/</div>
              <a href="#" className="link">Manage Reservation</a>
            </div>
          </Col>
        </ErrorBoundary>
        <ErrorBoundary name="zone-a">
          <Col>
            {itemId ? (
              <>
                <Row>
                  <Col sm="5">
                    <ProductInformation itemId={itemId} pricingGraphQlEnabled={isPricingGraphQlEnabled} />
                  </Col>
                  <Col sm="7" className="right-card">
                    <RentalReservationModifyFormProviders
                      reservationId={reservationId}
                      uuid={uuid}
                      storeId={storeId}
                      FDAv4Enabled={isFdaV4Enabled}
                      estimateGraphQlEnabled={isEstimateGraphQlEnabled}
                      graphQlEnabled={isReservationGraphQlEnabled}
                    >
                      <ReservationModifyForm />
                    </RentalReservationModifyFormProviders>
                  </Col>
                </Row>
              </>
            ) : (
              <div className="single-card">
                <div className="contents">
                  <RentalReservationModifyFormProviders
                    reservationId={reservationId}
                    uuid={uuid}
                    storeId={storeId}
                    FDAv4Enabled={isFdaV4Enabled}
                    estimateGraphQlEnabled={isEstimateGraphQlEnabled}
                  >
                    <ReservationModifyForm />
                  </RentalReservationModifyFormProviders>
                </div>
              </div>
            )}
          </Col>
        </ErrorBoundary>
      </Row>
    </QueryProvider>
  );
};

ManageReservation.displayName = 'ManageReservationPage';
